module.exports = __webpack_public_path__ + "img/faceToFace.c2209635.png";